import Vue from 'vue';
import App from './App.vue';
import router from './plugins/router';
import axios from './plugins/request';
import menu from './plugins/menu.js';
import cookies from 'js-cookie';
import './plugins/style.js';//全局样式
import './plugins/func.js';//全局方法
import './plugins/tool.js';//全局组件
import './style/config.css';
import './style/theme/index.css';
import './style/icon/iconfont.css'
import './style/icon/iconfont.js'

import VueECharts from 'vue-echarts'
import echarts from 'echarts';
Vue.use(VueECharts);
Vue.component('v-chart', VueECharts);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$menu = menu;
Vue.prototype.$cookie = cookies;
Vue.prototype.$dic = { all: {},project:{},category:{},expert:{}};

// Vue.prototype.$uid="";
// Vue.prototype.$did="";

Vue.prototype.$editAbled=true;
Vue.prototype.$nodeid="1728527079416";

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
Vue.prototype.$startPath = "/TourManagement";

// 在 main.js 中设置全局超时时间
axios.defaults.timeout = 50000;



